<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Report</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <collapse @getDataList="search">
        <collapse-item>
          <span>Agent:</span>
          <el-input
            placeholder="please enter name,email,address to search"
            v-model="queryInfoparams.params.keyword"
            clearable
            @change="search"
            @clear="queryInfoparams.params.keyword==null"
          ></el-input>
        </collapse-item>
        <collapse-item>
          <span>Test Date:</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            @change="dateChange"
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="Start Date"
            end-placeholder="End Date"
          ></el-date-picker>
        </collapse-item>
         <collapse-item>
          <span>Test Id:</span>
          <el-input
            placeholder="please Test Id to search"
            v-model="queryInfoparams.params.testId"
            clearable
            @change="search"
            @clear="queryInfoparams.params.testId==null"
          ></el-input>
        </collapse-item>
      </collapse>

      <el-row type="flex" justify="space-between">
        <div class="titleText">Report</div>
        <el-button-group class="btnsList">
          <el-button plain size="small" icon="el-icon-download" v-hasPermission="['report:excel']" @click="exportExcel">Export</el-button>
        </el-button-group>
      </el-row>

      <!-- 列表区域 -->
      <el-table
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
        @row-dblclick="dbClickHandler"
      >
        <!-- <el-table-column type="selection" width="55" label="No."></el-table-column> -->
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="Agent name" sortable="custom" prop="agencyName" width="150"></el-table-column>
        <el-table-column label="Test id" prop="testId" width="100"></el-table-column>
        <el-table-column label="Test date" sortable="custom" prop="testDate" width="150"></el-table-column>
        <el-table-column
          label="Result"
          prop="testResult"
          :filters="testResultList"
          column-key="testResult"
          width="100"
        ></el-table-column>

        <el-table-column label="Last name" sortable="custom" prop="lastName" width="150"></el-table-column>
        <el-table-column label="First name" sortable="custom" prop="firstName" width="150"></el-table-column>
        <el-table-column label="Plumbing company" sortable="custom" prop="companyName" width="200"></el-table-column>
        <el-table-column label="Email" sortable="custom" prop="email" width="200"></el-table-column>
        <el-table-column label="CC e-mail" sortable="custom" prop="ccemail" width="200"></el-table-column>
        <el-table-column label="Contact number" sortable="custom" prop="mobileNumber" width="150"></el-table-column>
        <el-table-column label="Post code" sortable="custom" prop="postCode" width="140"></el-table-column>
        <el-table-column label="Project name" sortable="custom" prop="projectAddress" width="200"></el-table-column>
        <el-table-column label="PipeBrand&Type" sortable="custom" prop="memo" width="180"></el-table-column>
        <el-table-column label="Site address" sortable="custom" prop="city" width="220"></el-table-column>
         <el-table-column label="Device ID" sortable="custom" prop="deviceUniqueCode" width="220"></el-table-column>

        <el-table-column
          label="Test type"
          prop="testType"
          :filters="testTypeList"
          column-key="testType"
          width="150"
        ></el-table-column>

        <el-table-column
          label="Test method"
          prop="testMethod"
          :filters="testMethodList"
          column-key="testMethod"
          width="150"
        ></el-table-column>

        <el-table-column label="Operation" width="100px" fixed="right">
          <template slot-scope="scope">
            <el-link icon="el-icon-s-setting" v-hasPermission="['report:download']" @click="download(scope.row)">Download</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      top="10px"
      @close="dialogClose"
      @open="open()"
      slot="title"
    >
     <template slot="title">
        <div>
          <h3>Test pressure record</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="Test Data" name="first">
          <el-form ref="form" label-width="200px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="Project Name">
                  <el-input disabled v-model="entity.projectName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Plumbing Company">
                  <el-input disabled v-model="entity.companyName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Site Address">
                  <el-input disabled v-model="entity.city"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CC e-mail">
                  <el-input disabled v-model="entity.ccemail"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Date">
                  <el-input disabled v-model="entity.testDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Post Code">
                  <el-input disabled v-model="entity.postCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Pipe Brand & Type">
                  <el-input disabled v-model="entity.memo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Testing Type">
                  <el-input disabled v-model="entity.testType"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Testing Method">
                  <el-input disabled  v-model="entity.testMethod"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Pressure at Start">
                  <el-input disabled v-model="entity.startPressure"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Pressure at End">
                  <el-input disabled v-model="entity.endPressure"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Testing Result">
                  <el-input disabled v-model="entity.testResult" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Test ID:">
                  <el-input disabled v-model="entity.testId" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div id="pressureChart" style="width:100%;" ></div>
          <div id="testData" style="width:100%;" v-if="isAdmin==true" >
            <el-row>
              <el-col :span="24">
               <h2>TestData</h2>
              </el-col>
              <el-col :span="24">
               <el-input
                  type="textarea"
                  :rows="5"
                  v-model="testData">
                </el-input>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Photos" name="second">
          
    
            <el-image class="block" v-for="src in photos" :key="src" :src="src" style="width: 200px; height: 200px" :preview-src-list="photos">
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
   
        </el-tab-pane>
        <el-tab-pane label="Batch Number" name="third">

          <el-table
            :data="pipingCodeTable"
            border
            style="width: 100%">
             <el-table-column
              type="index"
              label="Num"
              width="100px">
            </el-table-column>
            <el-table-column
              prop="pipecode"
              label="Code">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from '@/services/localstorage';
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 列表
      dataList: [],
      total: 0,
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      // 添加和修改用户的表单数据
      addForm: {
        status: 0,
        testStandard: 'STANDARD',
      },

      // 控制修改对话框的显示与隐藏
      dialogVisible: false,

      // 查询到的信息
      editForm: {},

      //checkbox选择的只
      multipleSelection: [],

      //下拉框查询参数：状态
      agencyStatus: '',
      //下拉框查询参数：测试标准
      testStandard: '',
      //下拉框数组
      testMethodList: [],
      testTypeList: [],
      testResultList: [],
      dateRange: '',

      dialogVisible: false,
      activeName: 'first',
      testId:null,
      entity:{},
      photos:[],
      pipingCodeTable:[],

      
      testData:null,

      isAdmin:false,
    }
  },
  methods: {
    dialogClose(){
     
      this.photos=[]
      this.entity={}
      this.pipingCodeTable=[]
      this.activeName='first'


      //删除已有的子节点，避免已创建的chart重复显示
    
       var chartDom = document.getElementById('pressureChart') 
        if(chartDom !=null && chartDom.childNodes !=null && chartDom.childNodes !=undefined){
              var childs = chartDom.childNodes; 
              for(var i = childs.length - 1; i >= 0; i--) {   
                chartDom.removeChild(childs[i]);   
              }  
        }
 
     
     this.dialogVisible = false
    },
    handleClick(tab, event) {
      // console.log(tab.index)
      var index =tab.index

    if(index==1){ //photos
      this.$get(`pipingDiagram/queryDiagram/${this.testId}`).then(({ data: res }) => {
        // console.log(res)
       this.photos= res.data
      
      })
    }else if(index==2){//code
      this.$get(`pipingCode/getByTestId/${this.testId}`).then(({ data: res }) => {
        // console.log(res)
       this.pipingCodeTable= res.data
      
      })
    }
      

    },
    // table双击事件，打开弹窗
    dbClickHandler(row, column, event) {
      const loading = this.$loading({
        lock: true,
        text: 'loading ...'
      })
      this.dialogVisible = true
      this.testId = row.testId

       var user=db.get("user");
      var userType=user.userType;
      console.log('userType',userType)
      if(userType=='1'){//总部人员
          this.isAdmin=true
      }

      this.$get(`pressure/selectPressureRecordByTestId/${row.testId}`).then(({ data: res }) => {
        // console.log(res)
        this.entity= res.data
        loading.close()
      })
    },

    //监控下拉框变化
    filterChange(filters) {
      console.log('---------------', filters)

      if (filters.testType != undefined) {
        var testType = filters.testType

        if (testType.length > 0) {
          this.queryInfoparams.params.testType = testType.join(',')
        } else {
          this.queryInfoparams.params.testType = null
        }
      }

      if (filters.testMethod != undefined) {
        var testMethod = filters.testMethod

        if (testMethod.length > 0) {
          this.queryInfoparams.params.testMethod = testMethod.join(',')
        } else {
          this.queryInfoparams.params.testMethod = null
        }
      }

      if (filters.testResult != undefined) {
        var testResult = filters.testResult

        if (testResult.length > 0) {
          this.queryInfoparams.params.testResult = testResult.join(',')
        } else {
          this.queryInfoparams.params.testResult = null
        }
      }

      this.search()
    },
    dateChange(value) {
      console.log(value)
      if (value != null && value != undefined) {
        this.queryInfoparams.params.startDate = value[0]
        this.queryInfoparams.params.endDate = value[1]
      } else {
        this.queryInfoparams.params.startDate = null
        this.queryInfoparams.params.endDate = null
      }
    },
    //导出excel
    exportExcel() {
      console.log('-----------')
      let res = this.$export('report/exportExcel', JSON.stringify(this.queryInfoparams), 'report')
    },
    //获取数据字典列表
    getDictList() {
      this.$get(`dict/getByTypeCodeAsFilter/TEST_TYPE/ALL`).then(
        ({ data: res }) => {
          this.testTypeList = res.data
        }
      )
      this.$get(`dict/getByTypeCodeAsFilter/TEST_METHOD/ALL`).then(
        ({ data: res }) => {
          this.testMethodList = res.data
        }
      )
      this.$get(`dict/getByTypeCodeAsFilter/TEST_RESULT/ALL`).then(
        ({ data: res }) => {
          this.testResultList = res.data
        }
      )
    },

    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
     search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询用数据列表
    getDataList() {
      // 分页查询
      this.$post('report/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },

    // 下载
    download(record) {
      this.$downloadPdf(
        '/Pdf/export/' + record.testId,
        {},
        'Pressure' + record.testId
      )
    },
    // 监听dialog的弹出事件，在nextTick回调中生成echart
    open() {

      //生成图表
     this.$get(`pressureChar/queryPressureRecordCharts/${this.testId}`).then(({ data: res }) => {
        // console.log(res.data)

          var charList =res.data
          var chartDom = document.getElementById('pressureChart')
          for(var i=0;i<charList.length;i++){
            var title=charList[i].pName
            var xAxisData=charList[i].point
            var series1data=charList[i].pressure 
            var series2data=charList[i].startPressure
            var oDiv = document.createElement('div');    
            
            console.log("日志" , series1data)
             console.log("标题" , title)
            oDiv.id='main'+i;           
            document.body.appendChild(oDiv);
            document.getElementById(oDiv.id).style.height='400px'
            document.getElementById(oDiv.id).style.width='55%'
            this.createChart(oDiv.id,title,xAxisData,series1data,series2data);
            chartDom.appendChild(oDiv);  
          }
           
      })
    //获取测压历史数据
      this.$get(`pressureChar/queryPressureRecordChart/${this.testId}`).then(({ data: res }) => {
        // console.log(res.data)
          if(res.data !=null){
            this.testData =res.data.record  
          }
          
         
      })

     
    },
    createChart(id,title,xAxisData,series1data,series2data){
      //  this.$nextTick(() => {
        var chartDom = document.getElementById(id)
        // console.log(this.$refs)
        var myChart = this.$echarts.init(chartDom)
        var option
        option = {
          title: {
            text: title,
            x: 'center',
          },
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },

          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: 'round',
              type: 'line',
              data: series1data,
            },
            {
              name: 'normal',
              type: 'line',
              data: series2data,
            },
          ],
        }

        option && myChart.setOption(option)
      // })
    }
  },
  mounted() {
    this.getDataList()
    this.getDictList()
    this.dialogClose()

     var user=db.get("user");
     var userType=user.userType;
     console.log('userType',userType)
     if(userType=='1'){//总部人员
        this.isAdmin=true
     }
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

.titleText {
  font-size: 14px;
  color: #a4a4a4;
}

/deep/.el-table__body-wrapper {
  user-select: none;
}
.block{
margin:10px

}
/deep/.el-dialog__body{
  padding-top:0px;
  margin-top: 0px;
}
</style>